import Vue from 'vue'
import VueRouter from 'vue-router'
import Hedear from '../components/Header.vue'
import { isMobile } from '../utils/utils'
import mobileHomeView from '../components/mobileCompoen/mobileHeader.vue'
import i18n from '../utils/i18n/i18n'

let isMobileFlagRoute = isMobile() ? 'mobileHomeView' : 'homeView'
console.log(isMobileFlagRoute);

Vue.use(VueRouter)

// 获取当前语言
const getCurrentLang = () => {
  return (i18n.locale || 'CN').toLowerCase();
}

// 基础路由配置
const baseRoutes = [
  {
    path: '/',
    redirect: to => {
      const lang = getCurrentLang();
      return { name: isMobileFlagRoute, params: { lang } };
    }
  },
  {
    path: '/:lang',
    redirect: to => {
      const lang = to.params.lang || getCurrentLang();
      return { name: isMobileFlagRoute, params: { lang } };
    }
  },
  {
    path: '/:lang/secondLevel/HomeView',
    name: 'secondLevel',
    component: Hedear,
    children: [
      {
        path: '/:lang/secondLevel/HomeView',
        name: 'homeView',
        component: () => import('../views/HomeView.vue')
      },
      {
        path: '/:lang/secondLevel/vocationalView',
        name: 'vocationalView',
        component: () => import('../views/vocationalView.vue')
      },
      {
        path: '/:lang/secondLevel/projectView',
        name: 'projectView',
        component: () => import('../views/projectView.vue')
      },
      {
        path: '/:lang/secondLevel/specialView',
        name: 'specialView',
        component: () => import('../views/specialView.vue')
      },
      {
        path: '/:lang/secondLevel/collegeView',
        name: 'collegeView',
        component: () => import('../views/collegeView.vue')
      },
      {
        path: '/:lang/secondLevel/recruitView',
        name: 'recruitView',
        component: () => import('../views/recruitView.vue')
      },
      {
        path: '/:lang/secondLevel/newsView',
        name: 'newsView',
        component: () => import('../views/newsView.vue')
      },
      {
        path: '/:lang/secondLevel/AboutView',
        name: 'AboutView',
        component: () => import('../views/AboutView.vue')
      },
      {
        path: '/:lang/secondLevel/contactUs',
        name: 'contactUs',
        component: () => import('../views/ContactUs.vue')
      },
    ]
  },
  {
    path: '/:lang/mobile',
    name: 'mobile',
    component: mobileHomeView,
    children: [
      {
        path: '/:lang/mobile/mobileHome',
        name: 'mobileHomeView',
        component: () => import('../views/mobile/mobileHome.vue'),
      },
      {
        path: '/:lang/mobile/mobileVocational',
        name: 'mobileVocational',
        component: () => import('../views/mobile/mobileVocational.vue')
      },
      {
        path: '/:lang/mobile/mobileProject',
        name: 'mobileProject',
        component: () => import('../views/mobile/mobileProject.vue')
      },
      {
        path: '/:lang/mobile/mobileSpecial',
        name: 'mobileSpecialView',
        component: () => import('../views/mobile/mobileSpecial.vue')
      },
      {
        path: '/:lang/mobile/mobileCollege',
        name: 'mobileCollege',
        component: () => import('../views/mobile/mobileCollege.vue')
      },
      {
        path: '/:lang/mobile/mobileRecruit',
        name: 'mobileRecruit',
        component: () => import('../views/mobile/mobileRecruit.vue')
      },
      {
        path: '/:lang/mobile/mobileNews',
        name: 'mobileNews',
        component: () => import('../views/mobile/mobileNews.vue')
      },
      {
        path: '/:lang/mobile/mobileAbout',
        name: 'mobileAbout',
        component: () => import('../views/mobile/mobileAbout.vue')
      },
      {
        path: '/:lang/mobile/mobileContact',
        name: 'mobileContact',
        component: () => import('../views/mobile/mobileContact.vue')
      },
    ]
  }
]

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: baseRoutes,
  scrollBehavior (to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
  // 检查URL中的语言参数
  const paramLang = to.params.lang;
  const availableLangs = ['cn', 'en', 'jp', 'ko'];
  
  // 如果路径中没有语言参数或语言参数无效
  if (!paramLang || !availableLangs.includes(paramLang.toLowerCase())) {
    // 获取当前语言并重定向
    const currentLang = getCurrentLang();
    
    // 构建带有语言参数的新路径
    const redirectPath = to.path === '/' ? 
      `/${currentLang}` : 
      `/${currentLang}${to.path}`;
      
    next({
      path: redirectPath,
      query: to.query,
      hash: to.hash
    });
  } else {
    // 确保i18n语言与URL语言同步
    const upperLang = paramLang.toUpperCase();
    if (i18n.locale !== upperLang) {
      i18n.locale = upperLang;
      localStorage.setItem('lang', upperLang);
    }
    next();
  }
});

export default router
